//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import {
  mdiCalendarToday,
  mdiClockOutline,
  mdiMapMarkerOutline,
  mdiClose,
  mdiCheck,
  mdiAlertCircleOutline,
  mdiCheckCircle,
  mdiAlertCircle,
  mdiCash,
  mdiGenderMaleFemale,
  mdiGenderFemale,
  mdiGenderMale,
  mdiSeal,
} from '@mdi/js'
import { formatCurrency } from '@core/utils'
import { useUtils } from '@core/libs/i18n'

export default {
  name: 'InfoCard',
  props: {
    title: {
      type: String,
      default: '',
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
      required: true,
    },
    date: {
      type: String,
      default: '',
    },
    location: {
      type: String,
      default: '',
    },
    level: {
      type: String,
      default: '',
    },
    price: {
      type: String,
      default: '',
    },
    genderCategory: {
      type: String,
      default: 'Mix',
    },
    startTime: {
      type: String,
      default: '',
    },
    cancelDate: {
      type: String,
      default: '',
    },
    isCancel: {
      type: Boolean,
      default: false,
    },
    canCancel: {
      type: Boolean,
      default: false,
    },
    isConfirm: {
      type: Boolean,
      default: false,
    },
    confirmDate: {
      type: String,
      default: '',
    },
    confirmCode: {
      type: String,
      default: '',
    },
    isPaid: {
      type: Boolean,
      default: false,
    },
    isNow: {
      type: Boolean,
      default: false,
    },
    paymentStatus: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { t } = useUtils()

    const resolveStatusType = status => {
      if (status === 'cancelled') return 'error'
      if (status === 'paid') return 'success'
      if (['pending', 'declined'].includes(status)) return 'warning'
      if (status === 'hold') return 'info'

      return 'warning'
    }

    const resolveStatusColor = status => {
      if (status === 'cancelled') return 'cancelled'
      if (status === 'paid') return 'paid'
      if (['pending', 'declined'].includes(status)) return 'pending'
      if (status === 'hold') return 'hold'

      return ''
    }

    const resolveStatusIcon = status => {
      if (status === 'cancelled') return mdiClose
      if (status === 'paid') return mdiCheck
      if (['pending', 'declined', 'hold'].includes(status)) return mdiAlertCircleOutline

      return ''
    }

    const resolveStatusText = status => {
      if (status === 'cancelled') return t('reservations.reservation_has_been_cancelled')
      if (status === 'paid') return t('reservations.reservation_was_paid')
      if (status === 'pending') return t('reservations.reservation_is_pending')
      if (status === 'declined') return t('reservations.reservation_was_declined')
      if (status === 'hold') {
        if (props.isNow) {
          return `${t('pay_dialog.reservation_will_be_charged_now')}  ${t('pay_dialog.card_ending_in')} ${
            props.confirmCode
          }.`
        }

        return `${t('pay_dialog.reservation_will_be_charged')} ${props.confirmDate} ${t('pay_dialog.card_ending_in')} ${
          props.confirmCode
        }.`
      }

      return ''
    }

    return {
      resolveStatusType,
      resolveStatusColor,
      resolveStatusIcon,
      resolveStatusText,
      formatCurrency,
      t,

      icons: {
        mdiCalendarToday,
        mdiClockOutline,
        mdiMapMarkerOutline,
        mdiClose,
        mdiCheck,
        mdiAlertCircleOutline,
        mdiCheckCircle,
        mdiAlertCircle,
        mdiCash,
        mdiGenderMaleFemale,
        mdiGenderFemale,
        mdiGenderMale,
        mdiSeal,
        level: require('@/assets/images/svg/level.svg'),
        gender: require('@/assets/images/svg/gender.svg'),
        locationPoint: require('@/assets/images/svg/location-point.svg'),
        moneyBill: require('@/assets/images/svg/money-bill.svg'),
      },
    }
  },
}
